<template>
  <v-container fluid>
    <v-tabs-items :value="current_item">
      <v-tab-item :value="'SettingAchievements'" class="py-3">
        <achievement-setting-tab/>
      </v-tab-item>
      <v-tab-item :value="'ListPortfolios'" class="py-3">
        <list-portfolios/>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import {mapState} from "vuex";
import AchievementSettingTab from "../../Tabs/AchievementSettingTab.vue";
import ListPortfolios from "../../Tabs/ListPortfolios.vue";

export default {
  name: "MainCardAdmin",

  components: {
    AchievementSettingTab,
    ListPortfolios,
  },

  computed: {
    ...mapState({
      current_item:state => state.achievement_tuning.current_item_tab,
    }),
  }
}
</script>

<style scoped>

</style>